import { Col } from '@amzn/stencil-react-components/layout';
import { IconChevronRightSmall } from '@amzn/stencil-react-icons';

/**
 * Trailing navigation chevron for list cards.
 * Used by AuditCard, TaskCard, and any future tappable list card.
 */
export function CardChevron(): JSX.Element {
  return (
    <Col justifyContent="center">
      <IconChevronRightSmall color="color.text.secondary" aria-hidden />
    </Col>
  );
}
